import { render, staticRenderFns } from "./AttentionWindow.vue?vue&type=template&id=bbf1725c&"
import script from "./AttentionWindow.vue?vue&type=script&lang=js&"
export * from "./AttentionWindow.vue?vue&type=script&lang=js&"
import style0 from "./AttentionWindow.vue?vue&type=style&index=0&id=bbf1725c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports